import { render, staticRenderFns } from "./AdvanceApproval.vue?vue&type=template&id=47803aaa&scoped=true"
import script from "./AdvanceApproval.vue?vue&type=script&lang=js"
export * from "./AdvanceApproval.vue?vue&type=script&lang=js"
import style0 from "./AdvanceApproval.vue?vue&type=style&index=0&id=47803aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47803aaa",
  null
  
)

export default component.exports